import {
  SET_SAVINGS_SETTINGS,
  SET_SAVINGS_SETTINGS_LOADING,
  SAVINGS_SETTINGS_SUCCESS,
  SAVINGS_SETTINGS_RESET,
} from "redux/actions/admin/pengaturanSimpanan/savingsSettings";

const initialState = {
  loading: false,
  submitSuccess: false,

  data: {
    principal_savings: 1000,
    mandatory_savings: 1000,
  },
};

const savingsSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SAVINGS_SETTINGS_LOADING:
      return {
        ...state,
        loading: action.load,
      };

    case SET_SAVINGS_SETTINGS:
      return {
        ...state,
        data: action.data,
      };

    case SAVINGS_SETTINGS_SUCCESS:
      return {
        ...state,
        submitSuccess: true,
      };

    case SAVINGS_SETTINGS_RESET:
      return {
        ...state,
        submitSuccess: false,
      };

    default:
      return state;
  }
};

export default savingsSettingsReducer;
